<template>
  <button @click="jumpAdd({ options_ids: [] })" class="kp-btn-action-sm kp-btn__success"><i class="fa fa-plus"></i></button>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: mapActions([
    'jumpAdd',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Add.vue?29d8b74d
 **/